import { useNavigate, useLocation } from "react-router-dom";
import { House, GridFour, UsersThree } from "@phosphor-icons/react";

/**
 * GlobalNav - Simple top navigation strip with Home & Dashboard links.
 * Appears on all inner pages, not on Home/Login/Admin.
 */
const HIDDEN_ROUTES = [
  "/", "/login", "/signup", "/forgot-password",
  "/admin", "/admin/dashboard", "/install", "/get-app",
  // Public, anyone-can-buy report landing pages — kept chrome-free for
  // marketing links shared on WhatsApp / social so visitors land straight
  // on the sales page without the dashboard strip on top.
  "/mahakundli", "/lalkitab", "/bnn", "/raj-yog", "/life-report",
  "/astro-report", "/vastu-report", "/numerology-report",
  "/astro-vastu-report", "/consultation",
  "/palmistry-report", "/face-reading-report",
];

export default function GlobalNav() {
  const navigate = useNavigate();
  const location = useLocation();

  if (HIDDEN_ROUTES.includes(location.pathname)) return null;
  // Public, no-auth pages shared with end-clients / for PDF capture — no consultant chrome.
  if (location.pathname.startsWith("/portal/") || location.pathname.startsWith("/print/")) return null;
  if (new URLSearchParams(location.search).get('embed') === '1') return null;
  // Hide entirely when a page is being rendered for server-side PDF capture.
  if (typeof window !== 'undefined' &&
      new URLSearchParams(window.location.search).get('print_native') === '1') {
    return null;
  }

  const isDashboard = location.pathname === "/dashboard";
  const isHome = location.pathname === "/";

  return (
    <div className="hidden md:block bg-[#2D2A26] border-b border-white/10 sticky top-0 z-[60]" data-testid="global-nav">
      <div className="max-w-7xl mx-auto px-4 flex items-center gap-1 h-9">
        {!isHome && (
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-1.5 px-3 py-1 rounded text-amber-300 hover:text-amber-200 hover:bg-white/10 transition-all text-xs font-medium"
            data-testid="quick-nav-home"
          >
            <House size={14} weight="fill" />
            Home
          </button>
        )}
        {!isDashboard && (
          <button
            onClick={() => navigate("/dashboard")}
            className="flex items-center gap-1.5 px-3 py-1 rounded text-white/80 hover:text-white hover:bg-white/10 transition-all text-xs font-medium"
            data-testid="quick-nav-dashboard"
          >
            <GridFour size={14} weight="fill" />
            Dashboard
          </button>
        )}
        <button
          onClick={() => navigate("/community")}
          className="flex items-center gap-1.5 px-3 py-1 rounded text-white/80 hover:text-amber-200 hover:bg-white/10 transition-all text-xs font-medium"
          data-testid="quick-nav-community"
        >
          <UsersThree size={14} weight="fill" />
          Community
        </button>
      </div>
    </div>
  );
}
